export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/distributor/credit/back/bill',
          name: 'distributor-credit-back-bill',
          component: () => import('./index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              { name: `授信` },
              { name: `授信账单` },
            ],
          },
        },
      ]
    },
  ]
};
